import AdminClass from './AdminClass';
export default AdminClass;
